import { render, staticRenderFns } from "./WholesalerLogo.vue?vue&type=template&id=779349b1"
import script from "./WholesalerLogo.vue?vue&type=script&lang=ts"
export * from "./WholesalerLogo.vue?vue&type=script&lang=ts"
import style0 from "./WholesalerLogo.vue?vue&type=style&index=0&id=779349b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports